import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/core/utils/stubs.js)
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function stubComponent(componentName) {
  return /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);

      throw new Error("Module '".concat(componentName, "' not found"));
    }

    _createClass(_class, null, [{
      key: "getInstance",
      value: function getInstance() {}
    }]);

    return _class;
  }();
}